import { manutencao_de_equivalencia_estudos_extra_rede } from "./manutencao-de-equivalencia-estudos-extra-rede/manutencao-de-equivalencia-estudos-extra-rede";
const manutencao_historico = [manutencao_de_equivalencia_estudos_extra_rede];

export { manutencao_historico };
